import { hasItemExpired } from './helpers';

const makeKey = (...params) => params.map((param) => param.toString()).join('_');

const HOUR = 60 * 60 * 1000;

export class DefaultCache {
    constructor(id, onCacheUpdate, initialCache = {}, hasExpired = hasItemExpired) {
        this.id = id;
        this.onUpdate = onCacheUpdate;
        this.cache = initialCache;
        this.hasExpired = hasExpired;
    }

    save(item, ...params) {
        if (params.length === 0) {
            throw Error('Cache save needs at least 1 argument to determine key!');
        }
        const key = makeKey(params);
        const expiresIn =
            Date.now() + (item.cacheControl?.maxAge ? item.cacheControl.maxAge * 1000 : HOUR);
        // const expiresIn = Date.now() + HOUR;
        this.cache[key] = { item, expiresIn };
        this.onUpdate(this.id);
        return expiresIn;
    }

    wipeCache = async () => {
        this.cache = {};
        await this.onUpdate(this.id, true);
    };

    load(...params) {
        const key = makeKey(params);
        const { item, expiresIn } = this.cache[key] || {};
        return this.hasExpired(expiresIn, item) ? null : item;
    }
}
